import { render, staticRenderFns } from "./BarChartRiddlesDuration.vue?vue&type=template&id=33e6761b&scoped=true&"
import script from "./BarChartRiddlesDuration.vue?vue&type=script&lang=js&"
export * from "./BarChartRiddlesDuration.vue?vue&type=script&lang=js&"
import style0 from "./BarChartRiddlesDuration.vue?vue&type=style&index=0&id=33e6761b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e6761b",
  null
  
)

export default component.exports